import { render, staticRenderFns } from "./index1-1.vue?vue&type=template&id=13135f9e&scoped=true&"
import script from "./index1-1.vue?vue&type=script&lang=js&"
export * from "./index1-1.vue?vue&type=script&lang=js&"
import style0 from "./index1-1.vue?vue&type=style&index=0&id=13135f9e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13135f9e",
  null
  
)

export default component.exports